import React from 'react';
import { sprintf } from 'sprintf';

import { SellingPoint } from 'components/SellingPoint';
import { VaultMessage } from 'vault/components/VaultMessage';

type Props = {
  artStreamActive: boolean;
};

export const EmptyVault: React.FC<Props> = ({ artStreamActive }) => {
  return (
    <div className='d-flex flex-column h-100'>
      <div className='flex-grow-1 d-flex align-items-center'>
        <VaultMessage />
      </div>
      <div className='mb-3'>
        <div className='text-center key-value key-value--vault mb-2'>3 Ways To Get Started</div>
        <div className='row'>
          <div className='col-12 col-sm mb-3 mb-sm-0'>
            <SellingPoint title='Browse Artworks' icon='trending-star'>
              <span
                dangerouslySetInnerHTML={{
                  __html: sprintf(
                    'Discover popular artworks on Sedition. Use code %s during checkout to get %s off your first purchase.',
                    '<pre class="d-inline copy-text-component copy-text-component--pre">1ST-EDITION</pre>',
                    '15%',
                  ),
                }}
              />
              <div className='mt-1 mt-sm-2'>
                <a
                  href={Routes.artworks_path() + '?order=popular'}
                  className='btn btn--medium btn--border'
                >
                  Browse popular artworks
                </a>
              </div>
            </SellingPoint>
          </div>
          <div className='col-12 col-sm mb-3 mb-sm-0'>
            {artStreamActive ? (
              <SellingPoint title='Enjoy Art Stream' icon='stream-slim'>
                {
                  'You are an Art Stream subscriber. Visit the Playlists page to enjoy unlimited access to the entire Sedition collection.'
                }
                <div className='mt-1 mt-sm-2'>
                  <a href={Routes.vault_playlists_path()} className='btn btn--medium btn--border'>
                    View playlists
                  </a>
                </div>
              </SellingPoint>
            ) : (
              <SellingPoint title='Subscribe to Art Stream' icon='stream-slim'>
                {'Art Stream allows you to enjoy the entire Sedition collection for a monthly fee.'}
                &nbsp;
                {
                  'As long as artworks are not sold out you can add them to your playlists and play them without watermarks.'
                }
                <div className='mt-1 mt-sm-2'>
                  <a href={Routes.art_stream_path()} className='btn btn--medium btn--border'>
                    Start Trial
                  </a>
                </div>
              </SellingPoint>
            )}
          </div>
          <div className='col-12 col-sm mb-3 mb-sm-0'>
            <SellingPoint title='Invite Friends' icon='friends'>
              {sprintf(
                'Invite a friend to Sedition and you will both receive an exclusive edition of %s',
                '',
              )}
              <em>Build The World That You Want To Belong In</em>
              &nbsp;
              {sprintf('by %s', 'Mark Titchner. ')}
              {'Invite more friends to earn more rewards.'}
              <div className='mt-1 mt-sm-2'>
                <a href={Routes.user_invites_path()} className='btn btn--medium btn--border'>
                  Invite Friends
                </a>
              </div>
            </SellingPoint>
          </div>
        </div>
      </div>
    </div>
  );
};
